import { render, staticRenderFns } from "./SolutionCatalog.vue?vue&type=template&id=4ffd5975&scoped=true&"
import script from "./SolutionCatalog.vue?vue&type=script&lang=js&"
export * from "./SolutionCatalog.vue?vue&type=script&lang=js&"
import style0 from "./SolutionCatalog.vue?vue&type=style&index=0&id=4ffd5975&prod&scoped=true&lang=less&"
import style1 from "./SolutionCatalog.vue?vue&type=style&index=1&id=4ffd5975&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd5975",
  null
  
)

export default component.exports